/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 * Сгруппированные по типам регистры
 * @export
 * @interface GetSidebarState200ResponseDataRegistriesCountRegistriesByType
 */
export interface GetSidebarState200ResponseDataRegistriesCountRegistriesByType {
  /**
   * Количество товарных знаков в регистре
   * @type {number}
   * @memberof GetSidebarState200ResponseDataRegistriesCountRegistriesByType
   */
  tmApplication: number
}

/**
 * Check if a given object implements the GetSidebarState200ResponseDataRegistriesCountRegistriesByType interface.
 */
export function instanceOfGetSidebarState200ResponseDataRegistriesCountRegistriesByType(
  value: object
): value is GetSidebarState200ResponseDataRegistriesCountRegistriesByType {
  if (!('tmApplication' in value) || value['tmApplication'] === undefined)
    return false
  return true
}

export function GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSON(
  json: any
): GetSidebarState200ResponseDataRegistriesCountRegistriesByType {
  return GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSONTyped(
    json,
    false
  )
}

export function GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200ResponseDataRegistriesCountRegistriesByType {
  if (json == null) {
    return json
  }
  return {
    tmApplication: json['tmApplication'],
  }
}

export function GetSidebarState200ResponseDataRegistriesCountRegistriesByTypeToJSON(
  value?: GetSidebarState200ResponseDataRegistriesCountRegistriesByType | null
): any {
  if (value == null) {
    return value
  }
  return {
    tmApplication: value['tmApplication'],
  }
}
